<template>
  <div class="container">
    <div class="box_main" style="display: flex;align-items: center;justify-content: center;">
        <div style="color:#fff;font-size:36px;">正在开发中，未开放...</div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      title: '',
      message_vibilty:true
    }
  },
  methods: {
  }
}
</script>
<style lang='less' scoped>
.container {
  position: relative;
  width: 100%;
  height:100%;
  background:url('../../assets/datacount.png') no-repeat;
  background-size: cover;
  
}

.box_main{
  position: absolute;
  top:-52px;
  left:0;
  right:0;
  bottom:0;
  overflow: hidden;
}

#iframeContain{
  width: 100%;
  height: 100%;
  border: 0;
  padding: 0;
  margin:0;
}
.message_user{
  width:200px;
  height:200px;
  position:absolute;
  background: #fff;
  left:50%;
  top:200px;
  padding: 24px 35px;
  margin-left: -100px;
  border-radius: 10px;
  box-sizing: 0 0 10px rgba(0,0,0,.3);
  .message_user_box{
    width:100%;
    height:100%;
    position: relative;
    color:#999;
    font-size:18px;
    line-height: 2;
    .close_mess{
      position:absolute;
      display: flex;
      align-items: center;
      justify-content: center; /* 水平均匀分布 */
      width:24px;
      height:24px;
      background: #3b8cff;
      border-radius: 24px;
      right:-20px;
      top:-10px;
      color:#fff;
      cursor: pointer;
    }
    span{
      color:#3b8cff;
    }
  }
}
</style>